import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

interface SlashBalanceResponse {
	VirtualAccountId: string;
	BalanceCents: number;
	FetchedAt: string;
}

const initialState: SlashBalanceResponse = {
	VirtualAccountId: "",
	BalanceCents: 0,
	FetchedAt: "",
};

export const { thunk: getBalance, slice: getBalanceSlice } = getThunkAndSlice<Record<string, never>, SlashBalanceResponse>({
	initialState,
	path: "/api/slash/balance",
});
